export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
export const UPDATE_CONVERSATION_LATEST = "UPDATE_CONVERSATION_LATEST";
export const SET_CONVERSATIONS_LOADING = "SET_CONVERSATIONS_LOADING";
export const SET_CONVERSATIONS_ERROR = "SET_CONVERSATIONS_ERROR";

export const SET_ACTIVE_CONVERSATION_USER = "SET_ACTIVE_CONVERSATION_USER";
export const SET_MESSAGES = "SET_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_MESSAGES_LOADING = "SET_MESSAGES_LOADING";
export const SET_MESSAGES_ERROR = "SET_MESSAGES_ERROR";

export const SET_SENDING_MESSAGE = "SET_SENDING_MESSAGE";
export const SET_SENDING_MESSAGE_ERROR = "SET_SENDING_MESSAGE_ERROR";
export const RESET_UNREAD_COUNT = "RESET_UNREAD_COUNT";
